<template>
  <div class="Index">

    <top @openPasswordDialog="openPasswordDialog"></top>
    <!--<left></left>
    <div class="IndexContainer l">
      <info v-if="menuPathKeys[0]==1"></info>
    </div>-->
    <home v-if="menuPathKeys[1]=='1-0'||(!menuPathKeys)" />
    <productFeatures v-if="menuPathKeys[1]=='1-1'" />
    <solutionsForTranslators v-if="menuPathKeys[1]=='2-1'" />
    <solutionsForTeams v-if="menuPathKeys[1]=='2-2'" />
    <solutionsForEnterprises v-if="menuPathKeys[1]=='2-3'" />
    <pricing v-if="menuPathKeys[0]=='3'" />
    <about v-if="menuPathKeys[0]=='4'" />
    <download v-if="menuPathKeys[1]=='1-2'" />
    <customerSupport v-if="menuPathKeys[1]=='5-1'" />
    <FAQs v-if="menuPathKeys[1]=='5-2'" />
    <contactUs v-if="menuPathKeys[1]=='5-3'" />
    <trustAndSecurity v-if="menuPathKeys[1]=='5-4'" />
    <el-dialog title="密码" :visible.sync="passwordDialogFlag" 
      class="dialog">
        <el-form label-position="left" label-width="100px">
          <el-form-item label="密码">
            <el-input size="small" v-model="filePassword" placeholder="请输入">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">           
          <el-button @click="confirmPassword">确认</el-button>
          <el-button @click="passwordDialogFlag=false">取消</el-button>
        </div>
    </el-dialog>
    <bottom />
  </div>
</template>

<script>
import top from '@/components/Top'
import left from '@/components/Left'
import info from '@/components/Info'
import bottom from '@/components/Bottom'
import home from '@/components/Home'
import productFeatures from '@/components/ProductFeatures'
import solutionsForTranslators from '@/components/SolutionsForTranslators'
import solutionsForTeams from '@/components/SolutionsForTeams'
import solutionsForEnterprises from '@/components/SolutionsForEnterprises'
import pricing from '@/components/Pricing'
import about from '@/components/About'
import download from '@/components/Download'
import customerSupport from '@/components/CustomerSupport'
import FAQs from '@/components/FAQs'
import contactUs from '@/components/ContactUs'
import trustAndSecurity from '@/components/TrustAndSecurity'
import {mapState} from 'vuex'
export default {
  name: 'index',
  data () {
    return {
      passwordDialogFlag:false,
      filePassword:'',
      fileUrl:'https://yiyo-static-new.oss-cn-hangzhou.aliyuncs.com/setup.exe',
    }
  },
  computed: {
    ...mapState(['menuPathKeys'])
  },
  mounted(){
    this.$nextTick(()=>{
      console.log(this.menuPathKeys,111)
    })
  },
  methods:{
    openPasswordDialog(childFileUrl){
      console.log('index123')
      this.fileUrl = childFileUrl;
      this.passwordDialogFlag = true;
      this.filePassword = '';
    },
    confirmPassword(){
      if(this.filePassword == 'jcic1234'){
        const a = document.createElement('a');
        a.href = this.fileUrl;
        a.download = "setup";
        a.style.display="none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.passwordDialogFlag=false;
      }
    },
  },
  components: {
    top : top,
    left : left,
    info : info,
    bottom:bottom,
    home:home,
    productFeatures:productFeatures,
    solutionsForTranslators:solutionsForTranslators,
    solutionsForTeams:solutionsForTeams,
    solutionsForEnterprises:solutionsForEnterprises,
    pricing:pricing,
    about:about,
    download:download,
    customerSupport:customerSupport,
    FAQs:FAQs,
    contactUs:contactUs,
    trustAndSecurity:trustAndSecurity,
  }
  // components: {
  //   top : top,
  //   left : left,
  //   info : info,
  //   bottom:bottom,
  //   home:home,
  //   productFeatures:home,
  //   solutionsForTranslators:home,
  //   solutionsForTeams:home,
  //   solutionsForEnterprises:home,
  //   pricing:pricing,
  //   about:about,
  //   download:home,
  //   customerSupport:customerSupport,
  //   FAQs:FAQs,
  //   contactUs:contactUs,
  //   trustAndSecurity:trustAndSecurity,
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Index {width:100%;padding-top:80px;background:#FFF;font-family: "Microsoft Yahei";}
.IndexContainer {width:100%;padding: 20px 30px;font-family: "Microsoft Yahei";font-size:13px;text-align: left;}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue